$(document).ready(function () {
    $('#cart > button').click(function () {
        $('body').addClass('cart-is-open');
    });
    $('.close-mini-cart-btn').click(function () {
        $('body').removeClass('cart-is-open');
    });
});